<div class="relative flex-1">
  <div class="absolute inset-0 flex flex-col gap-6 overflow-y-auto" [ngClass]="{ 'opacity-100': !isLoading(), 'opacity-0': isLoading() }">
    <!-- Tabs -->
    <p-tabs [value]="selectedTab" class="mt-8 min-h-[80dvh] flex-1" scrollable>
      <div class="flex items-center justify-between gap-4">
        <p-button severity="contrast" variant="outlined" (onClick)="onBackClick.emit()">{{ 'global.back' | transloco }}</p-button>
        <app-tabs
          [tabs]="tabs()"
          [selectedTab]="selectedTab"
          (selectedTabChange)="onChangeTab($event)"
          class="flex flex-1 justify-end"
          selectClass="flex flex-1 max-md:max-w-[65dvw]"
          tabsClass="flex-1 w-96" />
      </div>
      <p-tabpanels class="mt-8 flex-1">
        <!-- 0: Diagram with steps -->
        <p-tabpanel [value]="tabs()[0]?.value">
          <div class="flex flex-col gap-4 pb-8 md:h-full md:flex-row">
            <div class="relative rounded border border-zinc-100 max-md:order-2 md:max-h-[100dvh] md:w-1/3 md:overflow-y-auto">
              <app-steps
                [(activeStep)]="activeStep"
                [completeComponentData]="completeComponentData()"
                [svgComponent]="svgComponent"
                (onFinish)="onLastQuestionIsAnswered()" />
            </div>
            <div class="relative max-md:order-1 md:w-2/3">
              <div
                class="flex justify-center rounded border border-zinc-100 bg-zinc-50 max-md:min-h-[40dvh] md:absolute md:inset-0 md:overflow-hidden">
                <app-svg
                  #svgComponent
                  [id]="component()?.systemTypeId"
                  [url]="completeComponentData()?.localWiringImageConcise"
                  [padding]="40"
                  maxHeight="100%"
                  [withZoom]="true"
                  class="block flex-1 object-contain" />
              </div>
            </div>
          </div>
        </p-tabpanel>

        <!-- 1: Plug socket (pin table) image -->
        <p-tabpanel [value]="tabs()[1]?.value">
          <div class="relative h-full w-full">
            <div class="absolute inset-0 flex h-full w-full flex-col gap-4">
              @if (completeComponentData()?.ecuSideImage) {
                <div class="max-h-1/2 relative min-h-40 flex-1 rounded border border-gray-100 max-md:pt-8">
                  <h3 class="absolute left-2 top-2 rounded bg-white px-2 py-1 text-sm font-semibold">
                    {{ 'diagnosis.pinsView.front' | transloco }}
                  </h3>
                  <app-svg
                    #pinBoardFrontSvg
                    [url]="completeComponentData()?.ecuSideImage"
                    [padding]="40"
                    maxHeight="100%"
                    [withZoom]="true"
                    class="object-contain" />
                </div>
              }
              @if (completeComponentData()?.connectorSideImage) {
                <div class="max-h-1/2 relative min-h-40 flex-1 rounded border border-gray-100 max-md:pt-8">
                  <h3 class="absolute left-2 top-2 rounded bg-white p-2 text-sm font-semibold">
                    {{ 'diagnosis.pinsView.back' | transloco }}
                  </h3>
                  <app-svg
                    #pinBoardBackSvg
                    [url]="completeComponentData()?.connectorSideImage"
                    [padding]="40"
                    maxHeight="100%"
                    [withZoom]="true"
                    class="object-contain" />
                </div>
              }
            </div>
          </div>
        </p-tabpanel>
        <p-tabpanel [value]="tabs()[2]?.value">
          <div class="px-4 py-8">{{ 'diagnosis.noDataAvailable' | transloco }}</div>
        </p-tabpanel>
        <p-tabpanel [value]="tabs()[3]?.value">
          <div class="px-4 py-8">{{ 'diagnosis.noDataAvailable' | transloco }}</div>
        </p-tabpanel>
        <p-tabpanel [value]="tabs()[4]?.value">
          <div class="px-4 py-8">{{ 'diagnosis.noDataAvailable' | transloco }}</div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>

    <div (blur)="onLeaveRow()" (mouseleave)="onLeaveRow()">
      <!-- <p class="mt-4 rounded bg-slate-50">{{ completeComponentData()?.pinTable | json }}</p> -->
      <div class="w-full overflow-x-auto pb-6">
        <table class="mx-auto">
          <thead>
            <tr>
              <th class="border px-4 py-2 text-left">{{ 'diagnosis.pinTable.header.component1' | transloco }}</th>
              <th class="border px-4 py-2 text-left">{{ 'diagnosis.pinTable.header.pin1' | transloco }}</th>
              <th class="border px-4 py-2 text-left">{{ 'diagnosis.pinTable.header.component2' | transloco }}</th>
              <th class="border px-4 py-2 text-left">{{ 'diagnosis.pinTable.header.pin2' | transloco }}</th>
              <th class="border px-4 py-2 text-left">{{ 'diagnosis.pinTable.header.colorCode1' | transloco }}</th>
              <th class="border px-4 py-2 text-left">{{ 'diagnosis.pinTable.header.colorCode2' | transloco }}</th>
              <th class="border px-4 py-2 text-left">{{ 'diagnosis.pinTable.header.voltage' | transloco }}</th>
              <th class="border px-4 py-2 text-center"></th>
            </tr>
          </thead>
          <tbody>
            @for (pin of pinTable(); track getTableKey(pin.name, $index)) {
              <tr
                role="button"
                tabindex="0"
                (mouseover)="hoverTableRow(pin.si)"
                (focus)="hoverTableRow(pin.si)"
                (blur)="onLeaveRow()"
                class="group hover:bg-blue-50">
                <td class="border px-4 py-2">{{ completeComponentData()?.componentCode }} - {{ completeComponentData()?.componentDescription }}</td>
                <td class="border px-4 py-2">{{ pin.pinNumber }}</td>
                <td class="border px-4 py-2 font-semibold group-hover:text-blue-700">{{ pin.name }} - {{ pin.description }}</td>
                <td class="border px-4 py-2 font-semibold group-hover:text-blue-700">{{ pin.pinName }}</td>
                <td class="border px-4 py-2">{{ pin.wireColor1 }}</td>
                <td class="border px-4 py-2">{{ pin.wireColor2 }}</td>
                <td class="border px-4 py-2">{{ pin.voltage }}</td>
                <td class="gap-2 border px-4 py-2">
                  <div class="flex min-w-24 justify-center gap-2">
                    <!-- {{ pin.supplied }} {{ pin.si }} | {{ pin.st }}, -->

                    @if (selectedTab === 1) {
                      <span>{{ 'diagnosis.pinTable.showPins' | transloco }}</span>
                      <p-toggleswitch (onChange)="displayPlugContact($event.checked, pin)" />
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- si controlunit335878972 ecomponent335879075 -->
  <!-- st: variantId-->

  <!-- Skeleton -->
  <div
    class="pointer-events-none absolute inset-0 mt-4 flex flex-col gap-6 overflow-hidden transition-opacity duration-1000 ease-out"
    [ngClass]="{ 'opacity-0': !isLoading(), 'opacity-100': isLoading() }">
    <div class="pointer-events-none mt-2 flex flex-1 animate-pulse flex-col gap-4">
      <div class="pointer-events-none flex h-16 flex-col justify-end rounded-md bg-stone-50 lg:h-[56]"></div>
      <div class="pointer-events-none flex flex-col gap-2 md:flex-1 md:flex-row">
        <div class="pointer-events-none rounded-md bg-stone-50 max-md:order-2 max-md:h-[15dvh] md:w-1/3"></div>
        <div class="pointer-events-nonerounded-md bg-stone-50 max-md:order-1 max-md:h-[40dvh] md:w-2/3"></div>
      </div>
    </div>
  </div>
</div>
